import type { FaireProductEntity } from "../../entity_types/product";

export const p_wqfprm3e78: FaireProductEntity = {
  token: "p_wqfprm3e78",
  type: "product",
  name: "Bauhaus",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/23ccf6e15ed407d7fecdcc5b5c8624ee12a342870c4f59ba00437a70b1349b9b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77a036368961ffb70897e855f6984c6a274002f5929fbfe35f974e48bb46a240.png",
    "https://cdn.faire.com/fastly/4ce417b6eedd0a0ecea9b2d6f61dd6e6e10473dfc02b82e24872517471949d15.png",
    "https://cdn.faire.com/fastly/3b9ba0b21f7781cfd0667745e710161634e6aec1aa93e32e18b0be03cbadcb89.png",
    "https://cdn.faire.com/fastly/cc8bb165bd750e1dd5bce0a58aa504eb145f5bed548b877cb46c6ef00f7bc386.png"
  ],
  priceDollars: 13.47,
  description: "Smooth—Robust—Smokey\n\n\nBackstory: Bauhaus was named as a playful response to the customer question \"which is your darkest one?”. \"The darkest one\" felt goth to us 80's kids and it quickly led us to the band Bauhaus.\n\nThis is the ultimate blend for fans of dark roast.\n\nOrigins: Bauhaus is the only coffee in our lineup defined by its roast profile rather than the origin of the green coffee. Expect sweet roasted notes, a full body, and dark chocolate.\n\nPairings: Pairs well with your heaviest mixes, such as Bauhaus' \"Double Dare\", NIN's \"Down In It\", Sleep's \"Dragonaut\".\n\nBrew: Brew. Use a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.",
  tags: [],
  msrpDollars: 19.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:12.766Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
